import React, { useState } from "react";
import "./DownloadDocPdf.css";
import {DownloadBriefPdf, DownloadBriefWord, DownloadProposalPdf, DownloadProposalWord } from "../../services/GenericAPI";
import { useLanguage } from "../../context/Languagecontext";
//import { Globals } from "../../global/Globals";

const DownloadDocPdf = (props) => {
 const { Globals ,languages, setLanguages } = useLanguage();
  const [isPdfDownloading, setIsPdfDownloading] = useState(false);
  const [isWordDownloading, setIsWordDownloading] =  useState(false);
  const title=(props?.proposalTitle).replace(/ +/g, "");
  
  const downLoadPDF = async () => {
    let pdfResponse;
    setIsPdfDownloading(true);
    try {
      if(props.proposalType === "Briefs"){
        pdfResponse = await DownloadBriefPdf(props.proposalId);
      }else{
        pdfResponse = await DownloadProposalPdf(props.proposalId, props.proposalDetailId,props.proposalType);
      }
      if (pdfResponse?.data) {
        const base64 = pdfResponse?.data?.content;
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = title+".pdf";
        document.body.appendChild(link);
        link.click();
        link.remove();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileUrl);
        setIsPdfDownloading(false);
      } else {
        console.error("Error: No file data available for download.");
        setIsPdfDownloading(false);
      }
    } catch (error) {
      console.error("Error in downloading the file:", error);
      setIsPdfDownloading(false);
    }
  };

  const downLoadDOC = async () => {
    let wordResponse;
    setIsWordDownloading(true);
    try {
      if(props.proposalType === "Briefs"){
        wordResponse = await DownloadBriefWord(props.proposalId);
      }else{
        wordResponse = await DownloadProposalWord(props.proposalId, props.proposalDetailId,props.proposalType);
      }
      if (wordResponse?.data) {
        const base64 = wordResponse?.data?.content;
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        const fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = title+".docx";
        document.body.appendChild(link);
        link.click();
        link.remove();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileUrl);
        setIsWordDownloading(false);
      } else {
        console.error("Error: No file data available for download.");
        setIsWordDownloading(false);
      }
    } catch (error) {
      console.error("Error in downloading the file:", error);
      setIsWordDownloading(false);
    }
  };

  return (
    <div className="DownloadDocPdf_Container">
      <div className={`DownloadDocPdf_Button ${isPdfDownloading ? "Downloading" :"" }`} disabled={isPdfDownloading} onClick={downLoadPDF}>
        <img className="pdfWordDownloadIcon" src={isPdfDownloading ? Globals.IMG.DOWNLOAD : Globals.IMG.DOWNLOAD_ACTIVE} alt="Download" /> 
        {Globals.DOWNLOADPDFWORD.PDF}
      </div>
      <div className={`DownloadDocPdf_Button ${isWordDownloading ? "Downloading" :"" }`}  disabled={isWordDownloading} onClick={downLoadDOC}>
      <img className="pdfWordDownloadIcon" src={isWordDownloading ? Globals.IMG.DOWNLOAD :  Globals.IMG.DOWNLOAD_ACTIVE} alt="Download" /> 
      {Globals.DOWNLOADPDFWORD.WORD}
      </div>
    </div>
  );
};

export default DownloadDocPdf;
